/* eslint-disable complexity */
import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { DialogTitle } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import useGetAllLabelType from 'api/productPackaging/packagingPrint/useGetAllLabelType';
import useGetAllShowIdentityType from 'api/productPackaging/packagingPrint/useGetAllShowIdentityType';
import useGetPrintPreferences from 'api/productPackaging/packagingPrint/useGetPrintPreferences';
import useSetPrintPreferences from 'api/productPackaging/packagingPrint/useSetPrintPreferences';
import useGetAllCodes from 'api/productPackaging/useGetAllCodes';
import React, { useEffect, useState } from 'react';

import SpinnerLoader from '../../../SpinnerLoader/SpinnerLoader';

const TIME_DISPLAY_OPTIONS = {
  date: 'date',
  time: 'time',
  none: 'none',
};

const ProductPrintSettingsModal = ({
  open,
  branchGuid,
  packGuid,
  handleClose,
}) => {
  const [labelType, setLabelType] = useState('');
  const [identityShowType, setIdentityShowType] = useState('');
  const [code1Guid, setCode1Guid] = useState('');
  const [code2Guid, setCode2Guid] = useState('');
  const [showPacking, setShowPacking] = useState('true');
  const [timeDisplayMode, setTimeDisplayMode] = useState(
    TIME_DISPLAY_OPTIONS.none,
  );
  const [emptyError, setEmptyError] = useState(false);

  const [getPackageSizeList, labelTypesLoading, packageSizeList] =
    useGetAllLabelType();
  const [getAllShowIdentityType, identityTypesLoading, allShowIdentityType] =
    useGetAllShowIdentityType();
  const [getAllCodes, getAllCodesLoading, allCodes] = useGetAllCodes();

  const [getDefaultPrefencess, getLoading, defaultPrefences] =
    useGetPrintPreferences();
  const [updatePrefences, updateLoading] = useSetPrintPreferences();

  useEffect(() => {
    getPackageSizeList();
    getAllShowIdentityType();
    getAllCodes({ branchGuid });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branchGuid]);

  const allCodesWithEmpty = [
    {
      key: '',
      value: 'هیچکدام',
    },
    ...allCodes,
  ];

  useEffect(() => {
    if (packGuid) {
      getDefaultPrefencess({ packGuid });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packGuid]);

  useEffect(() => {
    if (defaultPrefences) {
      setLabelType(defaultPrefences?.labelType || '');
      setIdentityShowType(defaultPrefences?.identityShowType || '');
      setCode1Guid(defaultPrefences?.code1Guid || '');
      setCode2Guid(defaultPrefences?.code2Guid || '');
      setShowPacking(String(defaultPrefences?.showPacking) || '');
      if (defaultPrefences?.showDateTime) {
        setTimeDisplayMode(TIME_DISPLAY_OPTIONS.time);
      } else if (defaultPrefences?.showDate) {
        setTimeDisplayMode(TIME_DISPLAY_OPTIONS.date);
      } else {
        setTimeDisplayMode(TIME_DISPLAY_OPTIONS.none);
      }
    }
  }, [defaultPrefences]);

  const submitCodeGroup = () => {
    if (labelType && identityShowType && showPacking && timeDisplayMode) {
      setEmptyError(false);
      updatePrefences({
        guid: packGuid,
        labelType,
        identityShowType,
        code1Guid,
        code2Guid,
        showPacking: showPacking === 'true',
        showDate: timeDisplayMode === TIME_DISPLAY_OPTIONS.date,
        showDateTime: timeDisplayMode === TIME_DISPLAY_OPTIONS.time,
        handleClose: () => handleClose(),
      });
    } else {
      setEmptyError(true);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} sx={{ direction: 'rtl' }}>
      <DialogTitle>تنظیمات چاپ</DialogTitle>

      {getLoading ? (
        <SpinnerLoader />
      ) : (
        <DialogContent sx={{ width: '600px' }}>
          <FilledWrapper>
            <FilledLabel>سایز</FilledLabel>
            <FormControl
              variant="standard"
              sx={{ width: 'calc(100% - 150px)' }}
              error={!labelType && emptyError}
            >
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={labelType}
                onChange={e => setLabelType(e.target.value)}
              >
                {labelTypesLoading ? (
                  <SpinnerLoader />
                ) : (
                  packageSizeList.map(type => (
                    <MenuItem
                      value={type.key}
                      key={type.key}
                      sx={{ direction: 'rtl' }}
                    >
                      {type.value}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </FilledWrapper>

          <FilledWrapper>
            <FilledLabel>نمایش شناسه</FilledLabel>
            <FormControl
              variant="standard"
              sx={{ width: 'calc(100% - 150px)' }}
              error={!identityShowType && emptyError}
            >
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={identityShowType}
                onChange={e => setIdentityShowType(e.target.value)}
              >
                {identityTypesLoading ? (
                  <SpinnerLoader />
                ) : (
                  allShowIdentityType.map(type => (
                    <MenuItem
                      value={type.key}
                      key={type.key}
                      sx={{ direction: 'rtl' }}
                    >
                      {type.value}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </FilledWrapper>

          <FilledWrapper>
            <FilledLabel>انتخاب کد اول</FilledLabel>
            <FormControl
              variant="standard"
              sx={{ width: 'calc(100% - 150px)' }}
              error={!code1Guid && emptyError}
            >
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={code1Guid}
                onChange={e => setCode1Guid(e.target.value)}
              >
                {getAllCodesLoading ? (
                  <SpinnerLoader />
                ) : (
                  allCodesWithEmpty?.map(type => (
                    <MenuItem
                      value={type.key}
                      key={type.key}
                      sx={{ direction: 'rtl' }}
                    >
                      {type.value}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </FilledWrapper>

          <FilledWrapper>
            <FilledLabel>انتخاب کد دوم</FilledLabel>
            <FormControl
              variant="standard"
              sx={{ width: 'calc(100% - 150px)' }}
              error={!code2Guid && emptyError}
            >
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={code2Guid}
                onChange={e => setCode2Guid(e.target.value)}
              >
                {getAllCodesLoading ? (
                  <SpinnerLoader />
                ) : (
                  allCodesWithEmpty?.map(type => (
                    <MenuItem
                      value={type.key}
                      key={type.key}
                      sx={{ direction: 'rtl' }}
                    >
                      {type.value}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </FilledWrapper>

          <FilledWrapper>
            <FilledLabel>نمایش بسته‌بندی</FilledLabel>
            <FormControl
              variant="standard"
              sx={{ width: 'calc(100% - 150px)' }}
              error={!showPacking && emptyError}
            >
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={showPacking}
                onChange={e => setShowPacking(e.target.value)}
              >
                <MenuItem value="true" key="true" sx={{ direction: 'rtl' }}>
                  بله
                </MenuItem>
                <MenuItem value="false" key="false" sx={{ direction: 'rtl' }}>
                  خیر
                </MenuItem>
              </Select>
            </FormControl>
          </FilledWrapper>

          <FilledWrapper>
            <FilledLabel>نمایش زمان</FilledLabel>
            <FormControl
              variant="standard"
              sx={{ width: 'calc(100% - 150px)' }}
              error={!timeDisplayMode && emptyError}
            >
              <Select
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={timeDisplayMode}
                onChange={e => setTimeDisplayMode(e.target.value)}
              >
                <MenuItem
                  value={TIME_DISPLAY_OPTIONS.date}
                  key={TIME_DISPLAY_OPTIONS.date}
                  sx={{ direction: 'rtl' }}
                >
                  نمایش تاریخ
                </MenuItem>
                <MenuItem
                  value={TIME_DISPLAY_OPTIONS.time}
                  key={TIME_DISPLAY_OPTIONS.time}
                  sx={{ direction: 'rtl' }}
                >
                  نمایش زمان
                </MenuItem>
                <MenuItem
                  value={TIME_DISPLAY_OPTIONS.none}
                  key={TIME_DISPLAY_OPTIONS.none}
                  sx={{ direction: 'rtl' }}
                >
                  عدم نمایش
                </MenuItem>
              </Select>
            </FormControl>
          </FilledWrapper>
        </DialogContent>
      )}

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          disabled={updateLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          onClick={submitCodeGroup}
          loading={updateLoading}
        >
          ویرایش
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ProductPrintSettingsModal;

const FilledWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const FilledAreaWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 30px;
  margin-top: 30px;
`;

const TextArea = styled.textarea`
  resize: vertical;
  width: calc(100% - 150px);
  padding: 10px;
  border-radius: 5px;
  ${({ error }) => error && 'border: 2px solid #d32f2f;'}

  &:focus {
    outline-color: #1976d2;
  }
`;

const FilledLabel = styled.label``;
